import { render } from "./InvestmentDetailPage.vue?vue&type=template&id=1967b5f6&scoped=true"
import script from "./InvestmentDetailPage.vue?vue&type=script&lang=js"
export * from "./InvestmentDetailPage.vue?vue&type=script&lang=js"

import "./InvestmentDetailPage.vue?vue&type=style&index=0&id=1967b5f6&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1967b5f6"

export default script